"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tree2String = exports.attrToString = void 0;
const attrToString = (attr) => Object.entries(attr)
    .map(([key, value]) => `${key}="${value}"`)
    .join(" ");
exports.attrToString = attrToString;
const elementToString = (tag, attr, children) => `<${tag} ${(0, exports.attrToString)(attr)}>${children}</${tag}>`;
const tree2String = (tree) => tree
    ?.map((node) => elementToString(node.tag, { ...node.attr }, (0, exports.tree2String)(node.child)))
    .join("\n");
exports.tree2String = tree2String;
